import { type HandlerFormComponent } from 'modules/workflows/contexts/WorkflowContext'

import { CompleteFormHandlerForm } from './CompleteFormHandlerForm'

export const VendorOnboardingHandlerForm = (props: HandlerFormComponent) => (
  <CompleteFormHandlerForm {...props} category="provider" />
)
